import React from 'react'

const ErrorView = ({ error }) => {
  if (!error) return null

  return (
    <div className="main-show-header">
      <p>{error}</p>
    </div>
  )
}

export default ErrorView

